/**
 * by wrl
 */
import * as Util from 'js/util/util'
import _$ from 'js/api/getdata.js'
import DeviceInfo from 'js/lib/device-info.js'
import store from 'store'

class SmartshareFeedback {
  /**
     * 构造函数 初始化变量
     * @param {*} metaData
     * @param {*} data
     */
  constructor(metaData, data) {
    // 构造函数初始话计时器
    // 总计时器
    this.totalTimer = null
    // 页数计时器
    this.pageTimer = null
    // 轮询定时器
    this.timePoll = null
    // 构造函数初始化变量
    this.linkInfo = metaData
    this.linkSmartshareInfoCode = data.deliverycode
    this.linkSmartshareInfo = data.ext
    this.type = ''
    this.deviceInfo = new DeviceInfo()
    // 根据需求阅读时间不为0
    this.readdingTime = 0
    this.readdingPageTime = 0
    // this.readdingLimitTime = 0;
    this.readdingCompletion = 0
    this.pageDates = []
    this.backType = 0
    this.sendId = ''
    this.smartshareUserName = ''
    this.uid = ''
    this.email = ''
    this.phone_number = ''
    // 组装back数据
    this.backParam = {}
    // 记录当前页（具有滞后性 当changepage的时候该值为上一个page）默认1
    this.currentPage = 1
    this.totalPage = 1
    // 记录下载次数
    this.downloadNum = 0
    // 记录当前预览的文件类型
    this.isDoc = true
    // 文档阅读开始时间
    this.creatTime = null
    // 轮询时间间隔
    this.interval = 5
    // 判断轮询间隔是否改变
    this.intervalIsChange = false
  }

  /**
     * 初始操作
     */
  async init() {
    // doc类型并且不是excel 需要监控每页数据
    // 是excel或者是图片 不需要每页数据 统一为一页
    // 初始话发送开始阅读数据并启动总定时器
    // 根据smartshare设置配置发送的用户信息
    if (this.linkSmartshareInfo.linkInfo.onlyStaff == 1) { // 内链
      this.smartshareUserName = store.getters.userInfo.user_name
      this.uid = store.getters.userInfo.uid
    } else if (this.linkSmartshareInfo.receiver_setting === 0) { // 不需要手机或邮箱
      this.smartshareUserName = ''
      this.uid = ''
      this.email = ''
      this.phone_number = ''
    } else { // 需要手机邮箱
      const tempInfo = JSON.parse(localStorage.getItem(`smartshareLinkToken${this.linkSmartshareInfoCode}`))
      this.smartshareUserName = tempInfo.emobileNum
      if (Util.validEmail(this.smartshareUserName)) { // 输入的是邮箱
        this.email = this.smartshareUserName
        this.phone_number = ''
      } else { // 输入的是手机号
        this.email = ''
        this.phone_number = this.smartshareUserName
      }
    }
    this.creatTime = new Date().getTime()
    this.backType = 0
    await this.send()
    this.startTimer()
    this.startPageTimer()
    this.backType = 1
    if (Util.getPreviewType(this.linkInfo) === 'doc' && !Util.isExcel(this.linkInfo.mime_type)) {
      this.isDoc = true
    } else if (Util.isExcel(this.linkInfo.mime_type) || Util.getPreviewType(this.linkInfo) === 'image') {
      this.isDoc = false
      // 非pdfjs加载的文件 先发送一次 type=1的反馈
      this.currentPage = 1
      this.totalPage = 1
    }
    // 经过初始后 轮询发送上报
    this.startTimePoll()
  }

  /**
     * 发送反馈信息
     */
  async send() {
    this.backParam = {
      sToken: this.linkSmartshareInfo.sToken,
      bindId: this.linkSmartshareInfoCode,
      progress: this.readdingCompletion,
      osType: this.deviceInfo.OS,
      device: this.deviceInfo.Device,
      backType: this.backType,
      readTime: this.readdingTime,
      downloadNum: this.downloadNum,
      user_name: this.smartshareUserName,
      uid: this.uid,
      email: this.email,
      phone_number: this.phone_number,
      receiverEmail: this.linkSmartshareInfo.createrEmail,
      receiverUid: this.linkInfo.delivery_creator_uid,
      id: this.sendId,
      pageArray: JSON.stringify(this.pageDates),
    }
    const sendId = await _$.postData('smartshareFeedback', this.backParam)
      .then((res) => {
        if (res && res.data && res.data.interval) {
          if (this.interval !== res.data.interval) {
            this.intervalIsChange = true
            this.startTimePoll()
            this.interval = res.data.interval
          }
        }
        return res && res.data && res.data && res.data.data.id
      }).catch((error) => {
        // 错this.误处理
      })
    this.sendId = sendId
    return sendId
  }

  /**
     * 启动总阅读时长计时器
     */
  startTimer() {
    // 总计时器每1秒跳一次
    if (!this.totalTimer) {
      this.totalTimer = setInterval(() => {
        this.readdingTime += 1
      }, 1000)
    }
  }

  /**
     * 关闭计时器
     */
  endTimer() {
    if (this.totalTimer) {
      clearInterval(this.totalTimer)
      this.totalTimer = null
    }
  }

  /**
     * 启动每页时长计时器
     */
  startPageTimer() {
    // 页计时器每1秒跳一次
    if (!this.pageTimer) {
      this.pageTimer = setInterval(() => {
        this.readdingPageTime += 1
      }, 1000)
    }
  }

  /**
     * 关闭计时器
     */
  endPageTimer() {
    if (this.pageTimer) {
      clearInterval(this.pageTimer)
      this.pageTimer = null
    }
  }

  /**
     * 开始轮询定时器
     */
  startTimePoll() {
    if (!this.timePoll) {
      // 先发一次 后面靠轮询发
      this.pollFeedback()
      this.timePoll = setInterval(() => {
        // 发送上报接口
        this.pollFeedback()
      }, this.interval * 1000)
    } else if (this.intervalIsChange) {
      // 如果时间间隔改变 注销之前的重新注册新的轮询
      this.intervalIsChange = false
      this.endTimePoll()
      this.timePoll = setInterval(() => {
        // 发送上报接口
        this.pollFeedback()
      }, this.interval * 1000)
    }
  }

  /**
     * 结束轮询定时器
     */
  endTimePoll() {
    if (this.timePoll) {
      clearInterval(this.timePoll)
      this.timePoll = null
    }
  }

  /**
     * 翻页触发
     * @param {*} param0
     */
  changePage({ currentPage = 1, totalPage = 1, oldPage = 1 }) {
    const tempCompletion = parseInt(currentPage / totalPage * 100)
    this.backType = 1
    this.readdingCompletion = this.readdingCompletion > tempCompletion ? this.readdingCompletion : tempCompletion < 1 ? 1 : tempCompletion
    // 翻页的时候马上上报一次之后再设置currentpage
    this.currentPage = oldPage
    this.pollFeedback()
    this.currentPage = currentPage
    // 这里处理一下单页计算时间，如果不重置0会造成翻页后有可能下一页阅读时间多几秒
    this.readdingPageTime = 0
  }

  /**
     * 组合每页阅读信息
     */
  comboPageDatas() {
    // 是图片或者excle文档类型的文件 需要在20s后才会将完成度记录100
    if (!this.isDoc && this.readdingTime >= 20) {
      this.readdingCompletion = 100
    } else if (!this.isDoc && this.readdingTime < 20) {
      this.readdingCompletion = 0
    }
    // 这里加入 3 秒的时间限定 滑页过快不记录
    if (this.readdingPageTime <= 3 && this.isDoc) return
    // 这里加入最大单页阅读时间 最大值 3600秒 60分钟
    if (this.readdingPageTime >= 3600) this.readdingPageTime = 3600
    if (this.pageDates.length <= 0) {
      // 数组是空的时候直接push
      this.pageDates.push({
        page_num: this.currentPage,
        read_time: this.readdingPageTime, // 总阅读时间会有2秒的提前量，这里手动加上
        create_time: this.creatTime,
      })
    } else {
      const isFind = this.pageDates.findIndex((item) => item.page_num == this.currentPage)
      if (isFind > -1) {
        // 找到了将时间累加
        this.pageDates[isFind].read_time += this.readdingPageTime
      } else {
        // 没找到说明是新页直接push
        this.pageDates.push({
          page_num: this.currentPage,
          read_time: this.readdingPageTime,
          create_time: this.creatTime,
        })
      }
    }
    this.readdingPageTime = 0
  }

  /**
     * 清空操作
     */
  clean() {
    this.endTimer()
    this.endPageTimer()
    this.endTimePoll()
  }

  /**
     * 监听关闭浏览器
     */
  onbeforeunload() {
    window.onbeforeunload = () => {
      // 关闭监听
      this.clean()
    }
  }

  /**
     * 下载监听
     */
  download() {
    this.downloadNum += 1
    // 点击下载立即执行一次上报 防止丢失
    this.pollFeedback()
  }

  /**
     * 总页数变化 只会执行一次
     * 这个方法的目的是考虑边界条件，
     * 例如文档只有一页，或者只停留在第一页阅读没有翻页，利用总页数的滞后行，
     * watch总页数变化，产生变化之后结算一下完成度，如果用户不翻页或者只有一页，也会有完成度的计算
     */
  pagesCount(totalPage) {
    this.totalPage = totalPage
    const tempCompletion = parseInt(this.currentPage / totalPage * 100)
    this.readdingCompletion = this.readdingCompletion > tempCompletion ? this.readdingCompletion : tempCompletion < 1 ? 1 : tempCompletion
  }

  /**
     * 轮询发送上报接口 backtype = 1
     * 单独拎出来 防止数据影响其他上报操作
     */
  pollFeedback() {
    this.comboPageDatas()
    this.send()
  }
}
export default SmartshareFeedback
